import ReactPixel from 'react-facebook-pixel';

const META_EVENT_MAP = {
  landing_page_view: { type: 'standard', name: 'PageView' },
  funnel_view: { type: 'standard', name: 'ViewContent' },
  funnel_variant_view: { type: 'custom', name: 'FunnelVariantView' },
  telegram_cta_click: { type: 'custom', name: 'TelegramCTAClick' },
};

let initializedPixelId = '';

function stringParam(value) {
  return typeof value === 'string' ? value : '';
}

function paramsFromAttribution(payload) {
  const latestParams = payload?.attribution?.latest_touch?.params;
  return latestParams && typeof latestParams === 'object' ? latestParams : {};
}

function hasWindow() {
  return typeof window !== 'undefined';
}

function getPixelId() {
  if (!hasWindow()) {
    return process.env.REACT_APP_META_PIXEL_ID || '';
  }

  return (
    process.env.REACT_APP_META_PIXEL_ID ||
    window.__FUNNEL_TEST_META_PIXEL_ID__ ||
    ''
  );
}

export function isMetaPixelConfigured() {
  return Boolean(getPixelId());
}

export function initMetaPixel() {
  const pixelId = getPixelId();
  if (!pixelId || !hasWindow()) {
    return false;
  }

  if (initializedPixelId === pixelId) {
    return true;
  }

  if (typeof window.fbq === 'function') {
    window.fbq('init', pixelId);
  } else {
    ReactPixel.init(pixelId, undefined, {
      autoConfig: true,
      debug: process.env.REACT_APP_FUNNEL_TRACKING_DEBUG === 'true',
    });
  }

  initializedPixelId = pixelId;
  return true;
}

function sendFbq(mapping, payload, eventID) {
  if (!hasWindow() || typeof window.fbq !== 'function') {
    return false;
  }

  const method = mapping.type === 'custom' ? 'trackCustom' : 'track';
  window.fbq(method, mapping.name, payload, { eventID });
  return true;
}

export function trackMetaEvent(eventName, payload, eventID) {
  const mapping = META_EVENT_MAP[eventName];
  if (!mapping || !initMetaPixel()) {
    return false;
  }

  const metaPayload = {
    funnel_variant: payload?.funnel_variant || '',
    z_source: payload?.z_source || '',
    z_campaign: payload?.z_campaign || '',
    z_ad: payload?.z_ad || '',
    route_path: payload?.route_path || '',
    page_url: payload?.page_url || '',
  };
  const params = paramsFromAttribution(payload);
  const meta = payload?.meta && typeof payload.meta === 'object' ? payload.meta : {};

  Object.assign(metaPayload, {
    fbclid: stringParam(meta.fbclid),
    fbp: stringParam(meta.fbp),
    fbc: stringParam(meta.fbc),
    utm_source: stringParam(params.utm_source),
    utm_medium: stringParam(params.utm_medium),
    utm_campaign: stringParam(params.utm_campaign),
    utm_content: stringParam(params.utm_content),
    utm_term: stringParam(params.utm_term),
    meta_campaign_id: stringParam(meta.meta_campaign_id),
    meta_adset_id: stringParam(meta.meta_adset_id),
    meta_ad_id: stringParam(meta.meta_ad_id),
    meta_placement: stringParam(meta.meta_placement),
  });

  if (sendFbq(mapping, metaPayload, eventID)) {
    return true;
  }

  if (mapping.type === 'custom') {
    ReactPixel.trackCustom(mapping.name, metaPayload, { eventID });
  } else if (mapping.name === 'PageView') {
    ReactPixel.track('PageView', metaPayload, { eventID });
  } else {
    ReactPixel.track(mapping.name, metaPayload, { eventID });
  }

  return true;
}
